module.exports = __webpack_public_path__ + "img/manual-grn-03-confirm-button.37c15548.png";